export enum InlinePlusWidgetEnabledTopic {
  ChinaEconomy = "264615",
  ChinaEURelations = "327955",
  ChinaTechnology = "326943",
  ChinaTrade = "506003",
  Diplomacy = "325340",
  ElectricNewEnergyVehicles = "326140",
  USChinaRelations = "265568",
  USChinaTechWar = "500915",
  USChinaTradeWar = "326745",
}

export const InlinePlusWidgetEnabledTopics = [
  InlinePlusWidgetEnabledTopic.ChinaEconomy,
  InlinePlusWidgetEnabledTopic.USChinaRelations,
  InlinePlusWidgetEnabledTopic.USChinaTradeWar,
  InlinePlusWidgetEnabledTopic.ChinaTrade,
  InlinePlusWidgetEnabledTopic.ChinaEURelations,
  InlinePlusWidgetEnabledTopic.Diplomacy,
  InlinePlusWidgetEnabledTopic.USChinaTechWar,
  InlinePlusWidgetEnabledTopic.ChinaTechnology,
  InlinePlusWidgetEnabledTopic.ElectricNewEnergyVehicles,
] as string[];
